module.exports = __webpack_public_path__ + "img/promotion-1.81a6efd7.png";